import { createAction, props } from '@ngrx/store';

export const formMapSelected = createAction(
	'[Form Map] Form Map Selected',
	props<{ coordinates: { lat: number; lon: number } }>()
);

export const pinDropped = createAction(
	'[Form Map] Pin Dropped',
	props<{ latlng: { latitude: number; longitude: number } }>()
);

export const formMapDestroyed = createAction('[Form Map] Form Map Destroyed');
